import { env } from "@brz-env";
import Axios from "axios";
import axiosRetry from 'axios-retry';

// Create Client
const client = Axios.create({ baseURL: env.BRZ_API_ENDPOINT });
// Setup retries
axiosRetry(client, {
    retries: 3,
    retryDelay: (retryCount: number) => {
        return retryCount * 1000;
    }, // axiosRetry.exponentialDelay,
    retryCondition: () => {
        return true;
    },
    onRetry: (count: number) => {
        console.log('Retrying cio request:', count);
    }
});

export const identifyCustomer = async (url: string, data = {}) => {

    try {
        const res = await client.post(url, data, {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                'Access-Control-Allow-Origin': "*",
            }
        });

        if ( res.status !== 200 ) {
            return {
                status: 'error',
                error: res.statusText
            };
        }

        if ( res.data !== 'ok' ) {
            return {
                status: 'error',
                error: res.data
            };
        }

        return {
            status: 'ok',
            error: null,
        }

    } catch (error) {
        return {
            status: 'error',
            error: error?.toString()
        };
    }
};